<h1>Trucking Management</h1>
<nav mat-tab-nav-bar>
  <a
    mat-tab-link
    *ngFor="let link of navLinks | featureFlag | async; trackBy: trackByLabel"
    [routerLink]="link.path"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
    disableRipple="true"
  >
    {{ link.label }}
  </a>
</nav>
<router-outlet></router-outlet>
